<template>
	<v-card
		variant="flat"
	>
		<v-card-title>
			<translate>{{ title }}</translate>
		</v-card-title>
		<v-card-text>
			<v-row	v-if="description.length">
				<v-col>
					<translate>{{ description }}</translate>
				</v-col>
			</v-row>
			<v-row>
				<v-col>
					<v-divider class="mt-2" />
				</v-col>
			</v-row>
			<v-row
				v-for="visibleQuestion in visibleQuestions"
				:key="visibleQuestion"
			>
				<v-col>
					<div
						v-if="questionGraph[visibleQuestion]['type'] === 'note'"
					>
						<v-sheet
							color="grey-lighten-4"
							class="pa-4"
							rounded
						>
							<!-- eslint-disable-next-line vue/no-v-html value rendered directly from db, so it's safe-->
							<span v-html="$gettext(questionGraph[visibleQuestion]['text'])" />
						</v-sheet>
					</div>
					<div
						v-else
						class="mb-2 text-subtitle-1"
					>
						<translate>{{ questionGraph[visibleQuestion]['text'] }}</translate>
					</div>
					<div
						v-if="questionGraph[visibleQuestion]['type'] === 'open'"
					>
						<v-textarea
							variant="outlined"
							:model-value="questionGraph[visibleQuestion]['answer']"
							:error-messages="errors.answersSpecifics[visibleQuestion]"
							@update:model-value="updated => {
								update(`${visibleQuestion}.answer`, updated);
								$emit('answer')
							}"
						/>
					</div>
					<div
						v-else-if="questionGraph[visibleQuestion]['type'] === 'date'"
						class="ml-4 mr-4"
					>
						<v-row>
							<v-col
								cols="12"
								sm="4"
							>
								<date-picker
									:model-value="questionGraph[visibleQuestion]['answer']['date']"
									:error-messages="errors.answersSpecifics[visibleQuestion]"
									:label="$gettext('Date')"
									prepend-icon="$calendarEvent"
									@update:model-value="updated => {
										update(`${visibleQuestion}.answer.date`, updated);
										$emit('answer')
									}"
								/>
							</v-col>
							<v-col>
								<time-select
									:model-value="questionGraph[visibleQuestion]['answer']['time']"
									:error-messages="errors.answersSpecifics[visibleQuestion]"
									prepend-icon="$clockOutline"
									@update:model-value="updated => {
										update(`${visibleQuestion}.answer.time`, updated);
										$emit('answer')
									}"
								/>
							</v-col>
						</v-row>
					</div>
					<div
						v-else-if="questionGraph[visibleQuestion]['type'] === 'note'"
						class="ml-4 mr-4"
					/>
					<div
						v-else-if="questionGraph[visibleQuestion]['type'] === 'file'"
						class="ml-4 mr-4"
					>
						<v-file-input
							:model-value="questionGraph[visibleQuestion]['answer']"
							:label="$gettext(questionGraph[visibleQuestion]['text'])"
							accept="image/*,.pdf"
							variant="outlined"
							@update:model-value="updated => {
								update(`${visibleQuestion}.answer`, updated);
								$emit('answer')
							}"
						/>
					</div>
					<div
						v-else
					>
						<v-radio-group
							:model-value="questionGraph[visibleQuestion]['answer']"
							:error-messages="errors.answersSpecifics[visibleQuestion]"
							@update:model-value="updated => {
								update(`${visibleQuestion}.answer`, updated);
								$emit('choice', {question: visibleQuestion, answer: updated});
							}"
						>
							<v-radio
								v-for="(answer, id) in questionGraph[visibleQuestion]['answers']"
								:key="id"
								:value="id"
								:label="$gettext(answer.text)"
								color="primary"
							/>
						</v-radio-group>
					</div>
				</v-col>
			</v-row>
		</v-card-text>
	</v-card>
</template>

<script>
import TimeSelect from './TimeSelect.vue';
import {
	set, cloneDeep,
} from 'lodash';

export default {
	name: 'ClaimFormSection',
	components: {
		TimeSelect
	},
	props: {
		title: {
			type: String,
			required: true
		},
		description: {
			type: String,
			required: true
		},
		visibleQuestions: {
			type: Array,
			required: true
		},
		questionGraph: {
			type: Object,
			required: true
		},
		errors: {
			type: Object,
			required: true
		},
	},
	emits: ['answer', 'choice', 'update:question-graph',],
	methods: {
		/**
		 * @param {string} key
		 * @param {string} value
		 */
		update (key, value) {
			const updated = cloneDeep(this.questionGraph);

			set(updated, key, value);

			this.$emit('update:question-graph', updated);
		}

	}
};
</script>
<style scoped>
hr {
	margin-top: 0px;
	margin-bottom: 0px;
	border-color: rgb(97, 97, 97);
}
</style>
